import type { ReactNode } from 'react'
import './SettingsRow.scss'

interface SettingsRowProps {
  /** Optional element rendered BEFORE the label block (far-left position).
   *  Used for previews like the avatar squircle in the Profile row. */
  leading?: ReactNode
  /** Main label, e.g. "Erscheinung". */
  label: string
  /** Optional description shown under the label in a smaller, faded style. */
  description?: ReactNode
  /** Control rendered on the right side (SegmentedControl, Switch, Select, …). */
  control: ReactNode
  /** Id of the form control — when set, the label is rendered as `<label htmlFor>`. */
  htmlFor?: string
  className?: string
}

/**
 * Single row in a Settings section: optional leading preview, then
 * label/description in the middle, then the control on the right —
 * separated by `gap`. Matches the Figma "Group" pattern.
 */
export function SettingsRow({ leading, label, description, control, htmlFor, className }: SettingsRowProps) {
  const LabelTag = htmlFor ? 'label' : 'span'
  return (
    <div className={`settings-row ${className ?? ''}`.trim()}>
      {leading && <div className="settings-row__leading">{leading}</div>}
      <div className="settings-row__text">
        <LabelTag className="settings-row__label" htmlFor={htmlFor}>
          {label}
        </LabelTag>
        {description && <p className="settings-row__description">{description}</p>}
      </div>
      <div className="settings-row__control">{control}</div>
    </div>
  )
}
